// extracted by mini-css-extract-plugin
export default {"featureCardGroup":"OrderList_featureCardGroup__R7ivW","refunded":"OrderList_refunded__DNAe6","badge":"OrderList_badge__ShdOW"};